import React from 'react';
import { Link } from 'react-router-dom';
import Icon from 'components/AppIcon';

const NotFound = () => {
  return (
    <div className="min-h-screen bg-background flex items-center justify-center px-4">
      <div className="max-w-md w-full text-center">
        <div className="mb-8">
          <div className="w-24 h-24 bg-primary-100 rounded-full flex items-center justify-center mx-auto mb-6">
            <Icon name="AlertCircle" size={48} color="var(--color-primary)" />
          </div>
          <h1 className="text-4xl font-heading font-semibold text-text-primary mb-4">
            404
          </h1>
          <h2 className="text-xl font-heading font-medium text-text-primary mb-2">
            Page Not Found
          </h2>
          <p className="text-text-secondary mb-8">
            The page you're looking for doesn't exist or has been moved.
          </p>
        </div>
        
        <div className="space-y-4">
          <Link
            to="/assessment-welcome-introduction"
            className="btn-primary w-full inline-flex items-center justify-center space-x-2"
          >
            <Icon name="Home" size={20} />
            <span>Return to Assessment</span>
          </Link>
          
          <button
            onClick={() => window.history.back()}
            className="w-full px-6 py-3 bg-surface border border-border rounded-lg text-text-primary font-medium hover:bg-surface-secondary transition-all duration-200"
          >
            Go Back
          </button>
        </div>
      </div>
    </div>
  );
};

export default NotFound;